import { get, find } from "lodash";
import { Button } from "primereact/button";
import { Menubar } from "primereact/menubar";
import { PageRequestError } from "components/PageRequestError";
import { ProgressSpinner } from "primereact/progressspinner";
import { Title } from "components/Title";
import useApp from "hooks/useApp";
import ActionsEditPage from "pages/actions/Edit";
import { useTranslation } from "react-i18next";
import useViewPage from "hooks/useViewPage";
const ActionsViewPage = (props) => {
  const app = useApp();
  const pageController = useViewPage(props);
  const { t } = useTranslation();
  const EDIT = t("EDIT");
  const DELETE = t("DELETE");
  const { item, pageReady, loading, apiRequestError, deleteItem } =
    pageController;
  function ActionButton(data) {
    const items = [
      {
        label: EDIT,
        command: (event) => {
          app.openPageDialog(
            <ActionsEditPage
              isSubPage
              id={data.id}
              organisations={props.organisations}
              modules={props.modules}
            />,
            { closeBtn: true }
          );
        },
        icon: "pi pi-pencil",
      },
      {
        label: DELETE,
        command: (event) => {
          deleteItem(data.id, "actions/delete_action");
        },
        icon: "pi pi-trash",
      },
    ];
    return <Menubar className="p-0 " model={items} />;
  }
  function PageFooter() {
    if (props.showFooter) {
      return <div className="flex justify-content-between"></div>;
    }
  }
  if (loading) {
    return (
      <div className="p-3 text-center">
        <ProgressSpinner style={{ width: "50px", height: "50px" }} />
      </div>
    );
  }
  if (apiRequestError) {
    return <PageRequestError error={apiRequestError} />;
  }
  if (pageReady) {
    const getOrgValue = (item) => {
      let orgName = "-";
      if (item && props.organisations.length > 0) {
        const org = find(
          props.organisations,
          (org) => get(org, "code") === get(item, "org_code")
        );
        orgName = org ? get(org, "name", "-") : "-";
      }
      return orgName;
    };
    const getModuleValue = (item) => {
      let moduleName = "-";
      if (item && props.modules.length > 0) {
        const module = find(
          props.modules,
          (mod) => get(mod, "id") === get(item, "module_id")
        );
        moduleName = module ? get(module, "module_name", "-") : "-";
      }
      return moduleName;
    };
    return (
      <div>
        <main id="ActionsViewPage" className="main-page">
          {props.showHeader && (
            <section className="page-section mb-3">
              <div className="container">
                <div className="grid align-items-center">
                  {!props.isSubPage && (
                    <div className="col-fixed ">
                      <Button
                        onClick={() => app.navigate(-1)}
                        label=""
                        className="p-button p-button-text "
                        icon="pi pi-arrow-left"
                      />
                    </div>
                  )}
                  <div className="col ">
                    <Title
                      title={t("ACTION_DETAILS")}
                      titleClass="text-2xl text-primary font-bold"
                      subTitleClass="text-500"
                      separator={false}
                    />
                  </div>
                </div>
              </div>
            </section>
          )}
          <section className="page-section ">
            <div className="container">
              <div className="grid ">
                <div className="col comp-grid">
                  <div>
                    <div className="mb-3 grid justify-content-start">
                      <div className="col-12 md:col-4">
                        <div className="card flex gap-3 align-items-center p-3 ">
                          <div className="">
                            <div className="text-400 font-medium mb-1">Id</div>
                            <div className="font-bold">
                              {get(item, "id", "-")}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 md:col-4">
                        <div className="card flex gap-3 align-items-center p-3 ">
                          <div className="">
                            <div className="text-400 font-medium mb-1">
                              {t("FACILITIES")}
                            </div>
                            <div className="font-bold">{getOrgValue(item)}</div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 md:col-4">
                        <div className="card flex gap-3 align-items-center p-3 ">
                          <div className="">
                            <div className="text-400 font-medium mb-1">
                              {t("MODULE")}
                            </div>
                            <div className="font-bold">
                              {getModuleValue(item)}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 md:col-4">
                        <div className="card flex gap-3 align-items-center p-3 ">
                          <div className="">
                            <div className="text-400 font-medium mb-1">
                              {t("NAME")}
                            </div>
                            <div className="font-bold">
                              {get(item, "action_name", "-")}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 md:col-4">
                        <div className="card flex gap-3 align-items-center p-3 ">
                          <div className="">
                            <div className="text-400 font-medium mb-1">
                              {t("METRICS_ID")}
                            </div>
                            <div className="font-bold">
                              {get(item, "metrics_id", "-")}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 md:col-4">
                        <div className="card flex gap-3 align-items-center p-3 ">
                          <div className="">
                            <div className="text-400 font-medium mb-1">
                              {t("DETAILS")}
                            </div>
                            <div className="font-bold">
                              {get(item, "details", "-")}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 md:col-4">
                        <div className="card flex gap-3 align-items-center p-3 ">
                          <div className="">
                            <div className="text-400 font-medium mb-1">
                              {t("SLA_TIME")}
                            </div>
                            <div className="font-bold">
                              {get(item, "sla_time", "-")}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex justify-content-between">
                      <div className="flex justify-content-start">
                        {ActionButton(item)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
        <PageFooter />
      </div>
    );
  }
};
const withDefaultProps = (Component) => {
  const WrappedComponent = (props) => {
    const { t } = useTranslation();
    const defaultProps = {
      id: null,
      primaryKey: "id",
      pageName: "actions",
      apiPath: "actions/get_action",
      routeName: "actionsview",
      msgBeforeDelete: t("ARE_YOU_SURE_TO_DELETE_ACTION"),
      msgTitle: t("DELETE_ACTION"),
      msgAfterDelete: t("ACTION_DELETED_SUCCESSFULLY"),
      showHeader: true,
      showFooter: true,
      exportButton: true,
      isSubPage: false,
    };
    return <Component {...defaultProps} {...props} />;
  };

  return WrappedComponent;
};
export default withDefaultProps(ActionsViewPage);
